import React, { Component, FC } from 'react';
import { Link } from 'react-router-dom';
import ButtonMU from '@material-ui/core/Button';
import '../../css/Main.css'
import { Image, Container, Row, Col, ListGroup, Button } from "react-bootstrap"
import ReactGA from 'react-ga';
ReactGA.initialize('UA-120282210-7');
const DownloadBtn = () => (
  <a className="download-a" href={"/TinyScratchpad-0.17.1.dmg"} download>
    <Button 
    className="shadow"
      onClick={() => {
        ReactGA.event({
          category: 'User',
          action: 'Download'
        });
      }}
      style={{
        width:"100%", 
        height:"100%",
        backgroundColor:"#5bc0de",
        borderWidth:0
      }} 
      type="submit">
        Download for your MacOS 
    </Button>
  </a>

)

class Home extends Component {
  render() {
    return (
      <Container className='container'>

        {/* <div style={{position:"absolute", width:"100%", left:0}} >
          <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path fill="red" fill-opacity="1" d="M0,256L34.3,224C68.6,192,137,128,206,122.7C274.3,117,343,171,411,192C480,213,549,203,617,170.7C685.7,139,754,85,823,64C891.4,43,960,53,1029,69.3C1097.1,85,1166,107,1234,106.7C1302.9,107,1371,85,1406,74.7L1440,64L1440,320L1405.7,320C1371.4,320,1303,320,1234,320C1165.7,320,1097,320,1029,320C960,320,891,320,823,320C754.3,320,686,320,617,320C548.6,320,480,320,411,320C342.9,320,274,320,206,320C137.1,320,69,320,34,320L0,320Z"></path>
          </svg>
          <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="red" fill-opacity="1" d="M0,256L34.3,224C68.6,192,137,128,206,122.7C274.3,117,343,171,411,192C480,213,549,203,617,170.7C685.7,139,754,85,823,64C891.4,43,960,53,1029,69.3C1097.1,85,1166,107,1234,106.7C1302.9,107,1371,85,1406,74.7L1440,64L1440,0L1405.7,0C1371.4,0,1303,0,1234,0C1165.7,0,1097,0,1029,0C960,0,891,0,823,0C754.3,0,686,0,617,0C548.6,0,480,0,411,0C342.9,0,274,0,206,0C137.1,0,69,0,34,0L0,0Z"></path></svg>
        </div> */}
        <h1 style={{marginTop:50, zIndex:10}} className="title">Tiny Scratchpad.js 📝</h1>
        <Row style={{backgroundColor:"#fff",}}>
          <Col md={"6"} style={{}} >          
              <Image 
                style={{
                width:"100%",
                borderRadius:7,
              }} 
                src={require("./ss.png")} fluid 
              />
          </Col>
          <Col md={"6"} >
            <ListGroup variant="flush">
              <ListGroup.Item className={"explain-item"}>🔥 ES6 support</ListGroup.Item>
              <ListGroup.Item className={"explain-item"}>🔥 Auto Complete</ListGroup.Item>
              <ListGroup.Item className={"explain-item"}>🔥 Quick access from menubar</ListGroup.Item>
              <ListGroup.Item className={"explain-item"}>🔥 Complete Shell env in terminal</ListGroup.Item>
              <ListGroup.Item className={"explain-item"}>🔥 Live results</ListGroup.Item>
              <ListGroup.Item className={"explain-item"}>🔥 Save your brand new script! 😊</ListGroup.Item>
            </ListGroup>
 
              
            <div style={{marginTop:20}}>
              <DownloadBtn/>
            </div>
          </Col>    
        </Row>

        <Container style={{marginTop:50}}>
          <Col style={{textAlign:"left"}}>
            <h3>Mini docs</h3>
            <p className="description">
            {"The tool will try detect node from "} 
            <code>
              /usr/local/bin/node
            </code> 
            {" in case your binary isnt there you can specify it manually following the instruction below"}</p>
            <p>
              {"* in the first line please specify the path to node like so "} 
              <br/>
              <code style={{backgroundColor:"white"}}>
              /* /path/to/node */
              </code>
            </p>
            <p>* to kill process<code>{" Command+Q"}</code></p>
            <p>* to Save script<code>{" Command+S"}</code></p>
          </Col>
        </Container>

        <Container className="arrow-container">
          <h4 className="title">Demo</h4>
          <i  className="fa fa-chevron-down arrow-down"></i>
        </Container>

        <Row className='gif'>
          <Col>
            <Image 
                style={{
                  borderRadius:7,
                }} 
                src={require("./speedup_opt2.gif")} fluid 
              />
          </Col>
        </Row>
      </Container>  
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Screens/Home/Home.js